export const API_URL = process.env.REACT_APP_API_URL;

export function getSettingUrl() {
    return API_URL + '/setting';
}

export function updateSettingUrl() {
    return API_URL + '/setting';
}

